<template>
  <div :id="'comment_' + comment.id" class="media mb-4">
    <!-- <img v-if="comment.user.avatar === null" class="d-flex mr-3 rounded-circle" :src="usersPath + 'avatar.svg'" width="50px" alt="user"> -->
    <!-- <img v-else class="d-flex mr-3 rounded-circle" :src="usersPath + comment.user.avatar" width="50px" alt="user"> -->
    <div class="media-body">
      <h5 class="mt-0">
        <router-link :to="'/users/' + comment.user.slug + '/posts'">{{ comment.user.name }}</router-link>
        <small class="ml-2">{{ comment.created_at }}</small>
        <button type="button" class="float-right" @click="deleteComment">
          <font-awesome-icon icon="times" />
        </button>
      </h5>
      {{ comment.body }}
    </div>
  </div>
</template>

<script>
  export default {
    props: [
      'comment'
    ],


    data: function () {
      return {
        usersPath: this.$baseURL + '/storage/users/'
      };
    },


    methods: {
      deleteComment() {
        this.$store.dispatch('message/update', {
          body: 'Are you sure you want to delete this Comment?',
          class: 'danger',
          confirm: true
        });

        this.$bus.$off('proceed');
        this.$bus.$once('proceed', () => {
          this.delete(this.comment);
          this.$store.dispatch('message/close');
        });
      },

      delete(comment) {
        this.$store.dispatch('comments/deleteComment', comment).
          then((response) => {
            // send successful message
            this.$toast.success(response.data.message);
          })
          .catch((error) => {
            // send error message
            this.$toast.error(error.response.data.message);
          });
      }
    }
  }
</script>